export function caixaTipo(value: number) {
  return value === 0 ? 'Entrada' : 'Saída';
}
